import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

// URL base de la API
// const API_URL = 'http://192.168.88.79:5003/';
const API_URL = getApiBaseUrl();


// Crear una instancia de Axios
const api = axios.create({
  baseURL: API_URL,
});

// Configurar un interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage
    const token = secureStorage.getItem('authToken');
    
    if (token) {
      // Agregar el token al encabezado de autorización
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Funciones para manejar las solicitudes

const getDatosCaballete = async () => {
  try {
    const response = await api.get('caballete');
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getCaballete = async (codigo) => {
  try {
    const response = await api.get(`caballete`, { params: { codigo } }); // Agrega el código como parámetro de consulta
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getOneDatosCaballete = async (id) => {
  try {
    const response = await api.get(`caballete/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const putEstado = async (id, data) => {
  try {
    const response = await api.put(`${API_URL}updateEstado/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error('Error al Actualizar los Datos: ', error.message);
  }
};

const PostDatos = async (datos) => {
  try {
    const response = await api.post('caballete', datos);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

export { getDatosCaballete, putEstado, PostDatos, getOneDatosCaballete, getCaballete };
